/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon32Regular = forwardRef('NatureFxLightningBIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.66 2.495C16.718 1.055 19 1.805 19 3.59V13h5.82c1.516 0 2.389 1.724 1.49 2.946l-9.97 13.56c-1.058 1.439-3.34.69-3.34-1.097V19H7.18c-1.516 0-2.389-1.724-1.49-2.946l9.97-13.56ZM17 4.048 7.477 17h5.673A1.85 1.85 0 0 1 15 18.85v9.102L24.523 15H18.85A1.85 1.85 0 0 1 17 13.15V4.048Z" })));
});
